/**
 * HM-387 cluster login PIN: 4 dots rappresentano il PIN inserito.
 * - default: cerchio bianco bordo grigio
 * - filled: bg arancio + scale 1.05 + shadow
 * - error: bg rosso + shake animation 400ms
 */
export function PinDots({ length, error }: { length: number; error: boolean }) {
  return (
    <div className="pin-dots" aria-label={`PIN length ${length} of 4`} data-testid="pin-dots">
      {[0, 1, 2, 3].map((i) => {
        const filled = i < length;
        const cls = error ? 'pin-dot error' : filled ? 'pin-dot filled' : 'pin-dot';
        return <div key={i} className={cls} data-testid={`pin-dot-${i}`} data-filled={filled} />;
      })}
    </div>
  );
}
